import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ compact = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={`jmi-theme-toggle ${compact ? 'compact' : ''}`}
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      <span className="toggle-track" aria-hidden="true">
        <span className="toggle-icon sun">☀</span>
        <span className="toggle-icon moon">☾</span>
        <span className={`toggle-thumb ${isDark ? 'to-dark' : 'to-light'}`} />
      </span>
      {!compact && (
        <span className="toggle-label">{isDark ? 'Light' : 'Dark'}</span>
      )}
    </button>
  );
};

export default ThemeToggle;
